import React from 'react';
import { useHistory } from 'react-router-dom';

import Logo from '../../assets/logo-agroreceita-black.svg';
import maintainUtm from '../../services/maintainUtm';
import { getCurrentPageIdWithDevice } from '../../services/maintainUtm/idPages';

import * as S from './styles';

const HeaderSite = () => {
    const history = useHistory();

    const redirectLogin = () => {
        const current = new URL(window.location.href);
        history.push({ pathname: '/login', search: current.search });
    }

    const redirectCadastro = () => {
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-headertestegratis`);
        history.push({ pathname: '/cadastro', search: search });
    }

    return (
        <S.Container>
            <S.HeaderPlans>
                <div className='image'>
                    <a href="https://agroreceita.com.br/">
                        <img src={Logo} alt="Logo AgroReceita" />
                    </a>
                </div>

                <div className='links'>
                    <a href="https://agroreceita.com.br/ajuda/">Ajuda</a>
                    <a href="/planos">Planos</a>
                    <a href="https://agroreceita.com.br/blog/">Blog</a>
                </div>

                <div className='buttons-plans'>
                    <button onClick={() => redirectLogin()}>Entrar</button>
                    <button onClick={() => redirectCadastro()}>Teste Grátis</button>
                </div>

                <div className='mobile-only'>
                    <a href="https://agroreceita.com.br/ajuda/">Ajuda</a>
                    <a onClick={() => redirectLogin()}>Entrar</a>
                </div>
            </S.HeaderPlans>
        </S.Container>
    );
}

export default HeaderSite;
